import { StateCreator } from 'zustand'
import { getProfessionTree as getProfessionTreeEndpoint } from '../api/endpoints'
import axiosInstant from '../api'
import { IProfession } from '../models/Profession.interface'


export interface ProfessionsSlice {
  professionsList: IProfession[],
  subProfessionLibrary: any,
  areaOfFocusLibrary: any,
  getProfessions: () => void,
  areProfessionsLoaded: boolean,
}

export const createProfessionsSlice: StateCreator<ProfessionsSlice, [], [], ProfessionsSlice> = (set, get) => {
  let isFetching = false;
  
  const getProfessionTree = async () => {
    
    if (get().areProfessionsLoaded || isFetching) {
      return;
    }
    
    try {
      isFetching = true;
      const response = await axiosInstant.get( getProfessionTreeEndpoint() )
      const { data, status } = response
      if (status === 200) {
        const tree = data.reduce( ( accumulator:any, item:any) => {
          accumulator[ item.id ] = item.subProfessions;
          return accumulator;
        }, {} );
        // Areas of Focus are L1-scoped, so index them by profession id too.
        const aofTree = data.reduce( ( accumulator:any, item:any) => {
          accumulator[ item.id ] = item.subSubProfessions || [];
          return accumulator;
        }, {} );
        const pList = data.map( ( item:any ) => ({ id: item.id, name: item.name, order: item.order }) );
        set(() => ({
          professionsList: pList,
          subProfessionLibrary: tree,
          areaOfFocusLibrary: aofTree,
          areProfessionsLoaded: true,
        }))
      }
    } catch (error) {
      console.error(error)
    } finally {
      isFetching = false;
    }
  }

  // inside the slice, before the return, guard for browser
  if (typeof window !== 'undefined') {
    queueMicrotask(() => {
      try { getProfessionTree(); } catch { /* noop */ }
    });
  }
  
  return {
    professionsList: [],
    subProfessionLibrary: {},
    areaOfFocusLibrary: {},
    getProfessions: getProfessionTree,
    areProfessionsLoaded: false
  }
}
